import script from "./Application.vue?vue&type=script&setup=true&lang=js"
export * from "./Application.vue?vue&type=script&setup=true&lang=js"

import "./Application.vue?vue&type=style&index=0&id=299fba81&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-299fba81"]])

export default __exports__